import React from "react";
import "./CompanyDescription.css";
import NavbarLogCompanyDescription from "./NavbarLog/NavbarLogCompanyDescription";

const CompanyDescription = () => {
  return (
    <div className="company-container">
      <NavbarLogCompanyDescription />
      <div
        className="company-wrapper"
        role="main"
        aria-label="Company description"
      >
        <div className="company-popup">
          <h1>About MWGTD</h1>
          <div className="company-content">
            <h2>Our Story</h2>
            <p>
              On April 20, 2018, MWGTD was founded in the heart of Monastir, the
              coastal jewel of the Tunisian Republic, where the Mediterranean
              intertwines its timeless legends with the breeze of modernity.
              Monastir was not merely a geographical location, but a profound
              source of inspiration for a group of bold dreamers who chose to
              challenge conventions and shape their vision by creating an entity
              that seamlessly blends global ambition with deep Tunisian roots.
              MWGTD emerged as a passionate dream — a vision carried by young
              pioneers determined to become a beacon of innovation in the
              business world.
            </p>
            <p>
              The beginning was a humble epic: a modest office illuminated by
              glowing ideas, where the founders gathered to draw plans for a
              future that transcended the city’s boundaries. Choosing Monastir
              as the headquarters was no coincidence but a strategic decision
              inspired by its position as a crossroads of cultures and a vibrant
              economic hub, where the scent of Phoenician and Roman history
              mingles with the energy of the present. By 2022, MWGTD took a
              decisive step toward solidifying its presence, officially
              registering under the tax identifier D17688, affirming its
              commitment to transparency and excellence.
            </p>
            <p>
              Since then, MWGTD has transformed into a symbol of resilience and
              creativity, carrying a story of unquenchable passion and boundless
              aspiration. Every step the company takes is a new chapter in an
              epic that began in the streets of Monastir, where the founders’
              dreams intertwine with the city’s vibrant rhythm, creating a
              legacy that inspires generations and lights the path of innovation
              in Tunisia and beyond.
            </p>
            <h2>Our Vision</h2>
            <p>
              We are redefining the concept of purchasing and investing. Through
              our innovative solutions, we provide you with the freedom to
              acquire any product or service you dream of and help you achieve
              financial independence through secure and profitable investments.
              With MWGTD, the future is in your hands.
            </p>
            <h2>Our Values</h2>
            <ul>
              <li>
                <strong>Transparency and Mutual Trust</strong>: We believe
                transparency is the foundation of strong relationships with our
                clients. We strive to build trust by delivering high-quality
                services and keeping our promises.
              </li>
              <li>
                <strong>Partnership for Success</strong>: We consider our
                clients as partners in success. We help them achieve their
                financial goals, and in return, their loyalty fuels our growth.
              </li>
              <li>
                <strong>Innovation and Excellence</strong>: We continuously seek
                to provide innovative solutions that meet our clients’ evolving
                needs, setting us apart from competitors and ensuring customer
                loyalty.
              </li>
              <li>
                <strong>Sustainable Growth</strong>: We believe that the
                company’s sustainable growth is closely tied to our clients’
                success. We aim for balanced growth that serves the interests of
                all stakeholders.
              </li>
              <li>
                <strong>Excellence</strong>: By eliminating the need for
                traditional guarantees, we offer you unprecedented flexibility.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDescription;
